'use client';

import { PageNavigation } from '@/components/client';
import { useCheckPartnerWebview } from '@/hooks/useCheckPartnerWebview';

//* www는 DesktopHeader·BottomNavShell이 탈출구를 갖지만 제휴 호스트는 둘 다 없다
export const PartnerEscapeNav = () => {
  const isPartnerWebview = useCheckPartnerWebview();

  return isPartnerWebview ? <PageNavigation /> : null;
};
